


















import Vue from "vue";
import AiFeedbackDialog from "../ai-search/ai-answer/AiFeedbackDialog.vue";
import storeHelper from "@/store/store-helper";
import { AiFeedbackRequest } from "@/types/ai/aiSearch";

export default Vue.extend({
    name: "AiFeedbackNotFound",
    components: { AiFeedbackDialog },
    props: {
        searchText: { type: [String, null], required: false, default: "" },
        portalId: { type: Number, required: true }
    },
    data: function () {
        return {
            isFeedbackDialogOpen: false
        };
    },
    methods: {
        handleSearchResultFeedbackClick() {
            this.isFeedbackDialogOpen = true;
        },
        async handleSubmitAsync(feedbackReason: string) {
            const feedbackInfo: AiFeedbackRequest = {
                search_text: this.searchText,
                portal_id: this.portalId.toString(),
                question_id: null,
                question_index: null,
                feedback: feedbackReason
            };
            await storeHelper.aiSearchStore.postAiFeedback(feedbackInfo);
        }
    }
});
